import { z } from 'zod';

export const workcellInstrumentSchema = z.object({
  bench: z.string(),
  driverName: z.string(),
  dataConnectorConfig: z
    .object({
      inputActions: z.array(z.string()).optional(),
      outputActions: z.array(z.string()).optional(),
    })
    .optional(),
  driverVersion: z.string(),
  capacity: z.number(),
  config: z.record(z.any()),
  is_slotless_container: z.boolean().optional(),
  mappings: z.array(z.string()).optional(),
  simulate: z.boolean().optional(),
  display_name: z.string().optional(),
});

export const workcellInstrumentsByIdSchema = z.record(workcellInstrumentSchema);

export const driverActionConfigAliasSchema = z.object({
  actionAlias: z.string(),
  replaceOriginal: z.boolean().optional(),
  hidden: z.undefined(),
});

export const driverActionConfigHiddenSchema = z.object({
  actionAlias: z.undefined(),
  replaceOriginal: z.undefined(),
  hidden: z.literal(true),
});

export const driverActionConfigSchema = z.union([
  driverActionConfigAliasSchema,
  driverActionConfigHiddenSchema,
]);

export const aliasConfigSchema = z.object({
  name: z.string(),
});

export const driverActionArgumentConfigSchema = z.object({
  alias: z.string().optional(),
  default: z.string().or(z.number()).optional(),
  description: z.string().optional(),
  examples: z.string().optional(),
  hidden: z.boolean().optional(),
});

export const driverActionOutputConfigSchema = z.object({
  hidden: z.boolean().optional(),
});

export const driverActionConfigsByActionNameSchema = z.record(
  z.object({
    hidden: z.boolean().optional(),
    aliases: z.array(aliasConfigSchema).optional(),
    args: z.record(driverActionArgumentConfigSchema).optional(),
    outputs: z.record(driverActionOutputConfigSchema).optional(),
  })
);

export const driverActionConfigsByActionNameByVersionedDriverNameSchema =
  z.record(driverActionConfigsByActionNameSchema);

export const workcellDataSchema = z.object({
  workcellInstrumentsById: z.record(workcellInstrumentSchema),
  driverActionConfigsByActionNameByVersionedDriverName:
    driverActionConfigsByActionNameByVersionedDriverNameSchema.optional(),
  workcellTransportConfigId: z.string().optional(),
  workcellTransportConfigType: z.enum(['V1', 'V3']).optional(),
  workcellTransportConfigVersion: z.number().optional(),
});
